module.exports = __webpack_public_path__ + "static/img/jxcb73.a593d2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jxcb73.jpg
// module id = bG/W
// module chunks = 73